export default __webpack_public_path__ + "static/media/Form102Certificate.a4e8a261.png";